import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'vc-file-uploader-document',
  templateUrl: './file-uploader-document.component.html',
  styleUrls: ['./file-uploader-document.component.scss']
})
export class FileUploaderDocumentComponent implements OnInit {
  @Input()
  file: File;
  @Output()
  onFileRemove: EventEmitter<File> = new EventEmitter();

  @ViewChild('preview', { static: false })
  preview: ElementRef;

  constructor() {}

  ngOnInit() {
    if (this.preview) {
      this.preview.nativeElement.style.backgroundImage = 'url(' + URL.createObjectURL(this.file) + ')';
    }
  }
}
